require('./bootstrap')

import React, { Suspense } from 'react'
import { render } from 'react-dom'
import { createInertiaApp } from '@inertiajs/react'
import { InertiaProgress } from '@inertiajs/progress'
import { router as Inertia } from '@inertiajs/react'
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

// Language package
import './i18n';

// Store
import { StateProvider } from '@/store'

// JQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel'
var isDevelopment = process.env.NODE_ENV === 'development'

if (!isDevelopment) {
    Sentry.init({
        dsn: 'https://4c7e91b5109a4788b2a2d895290dbe98@o424104.ingest.sentry.io/5823603',
        integrations: [new Integrations.BrowserTracing()],

        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        tracesSampleRate: 1.0,
    })
}

if (process.env.NODE_ENV === 'production') {
    Inertia.on("navigate", (event) => {
        gtag("js", new Date());
        gtag("config", "UA-236528497-1");
    });
}

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => import(`./Pages/${name}`),
    /*
    resolve: name => {
        // Remove the leading ./ if present
        const pageName = name.replace(/^\.\//, '');


        const pages = require.context(
            './Pages',
            true,
            /\.js$/
        );

        const wmsPages = require.context(
            '../wms/js/Pages',
            true,
            /\.js$/
        );

        try {
            // Try WMS pages first
            return wmsPages('./' + pageName + '.js');
        } catch (e) {
            try {
                // Then try regular pages
                return pages('./' + pageName + '.js');
            } catch (err) {
                console.error('Attempted paths:',
                    './Pages/' + page    setup ({ el, App, props }) {
        // Wrapping root App component instead of wrap for each component
        return render(<Suspense fallback={null}><SUncaught (in promise) ReferenceError: createRoot is not definedateProvider><App {...props} /></SUncaught></Suspense>, el)
    },
    },
    */
   /*
    setup({ el, App, props }) {
        // Wrapping root App component instead of wrap for each component
        return render(<Suspense fallback={null}><StateProvider><App {...props} /></StateProvider></Suspense>, el)
    },
    */
    setup({ el, App, props }) {
        const root = createRoot(el);
        root.render(
            <Suspense fallback={null}>
                <StateProvider>
                    <App {...props} />
                </StateProvider>
            </Suspense>
        );
    },
})

InertiaProgress.init({ color: '#4B5563' })
